<template>
  <div class="popover__container">
    <slot name="icon">
      <img class="icon" src="@/assets/images/1/ques.png" alt="">
    </slot>
    <div class="popover" :class="[
      {left: placement === 'left'},
      {top: placement === 'top'},
      {bottom: placement === 'bottom'},
      {right: placement === 'right'},
    ]">
      <div class="popover__arrow">
        <span class="popover__arrow-content"></span>
      </div>
      <div class="popover__content">
        {{text}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'c-popover',
  props: {
    placement: {
      type: String,
      default: () => {
        'top';
      },
    },
    text: {
      type: String,
      default: () => {
        '';
      },
    },
  },
  data() {
    return {

    };
  },
};
</script>
<style>
.popover__container {
  position: relative;
}
.popover__container .icon{
  width: 16px;
  display: block;
  height: fit-content;
  cursor: pointer;
}
.popover__container .icon:hover + .popover{
  display: block;
}

.popover {
  display: none;
  position: absolute;
  padding: 10px 16px;
  width: max-content;
  max-width: 300px;
  background: #FFFFFF;
  /* border: 1px solid #35429E; */
  box-shadow: 1px 1px 8px 0px rgba(213,218,255,1);
  transition: .3s;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #051189;
  letter-spacing: -0.16px;
  font-weight: 400;
}
.popover.left {
  top: 0;
  left: 20px;
}
.popover.right {
  top: 0;
  right: 20px;
}
.popover.top {
  bottom: 36px;
  left: 50%;
  transform: translateX(-50%);
}
.popover.bottom {
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.popover__arrow {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 14px;
  height: 12px;
  overflow: hidden;
  background: 0 0;
  pointer-events: none;
}
.popover__arrow-content{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 8px;
  height: 8px;
  margin: auto;
  background-color: #fff;
  content: "";
  pointer-events: auto;
}
.popover.top .popover__arrow {
  bottom: -10px;
}
.popover.top .popover__arrow-content {
  box-shadow: 1px 1px 8px 0px rgba(213,218,255,1);
  transform: translateY(-4.24264069px) rotate(45deg);
}
</style>
